import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';



const Partners = (): JSX.Element => {

	return (
		<div className="app-page partners-page">
			
			<h1>Pro partnery</h1>

			<div className='partners-text'>
				<p>Milí obchodní partneři,<br />
					velice si vážíme toho, že chcete ve své ordinaci nabízet naše produkty&nbsp;- že chcete Vašim pacientům dopřát komfort v&nbsp;pooperační péči.</p>
				
				<p>Pokud máte zájem o spolupráci, prosíme, vyplňte nejprve{' '}
					<Link to={NavigateRoutesEnum.partnersRegistration} className='disable-selection'>
						TENTO REGISTRAČNÍ FORMULÁŘ
					</Link>. Na&nbsp;jeho základě Vám zašleme obchodní podmínky a&nbsp;ceník. Vyplnění tohoto formuláře je zcela nezávazné a&nbsp;slouží pouze pro&nbsp;zaslání výše uvedených dokumentů.</p>
				
				<p>Pokud již našimi klienty jste a&nbsp;chcete učinit další objednávku, prosím, využijte{' '}
					<Link to={NavigateRoutesEnum.partnersOrder} className='disable-selection'>
						TENTO OBJEDNÁVKOVÝ FORMULÁŘ
					</Link>.</p>
			</div>

			<h2>CO ZÍSKÁTE PRODEJEM NAŠICH VÝROBKŮ?</h2>
			
			<ul>
				<li>spokojené pacienty a&nbsp;jejich majitele</li>
				
				<li>uvedeme Vás jako kontaktní místo pro&nbsp;zájemce o naše límce</li>
				
				<li>reklamu pro&nbsp;Vaši ordinaci</li>
				
				<li>potencionální nové klienty</li>
			</ul>

			<div className='partners-links'>
				<Link to={NavigateRoutesEnum.partnersOrder} className='app-form-button disable-selection'>
					Objednávkový formulář
				</Link>

				<Link to={NavigateRoutesEnum.partnersRegistration} className='app-form-button disable-selection'>
					Registrační formulář
				</Link>
			</div>

		</div>
	);
};

export default Partners;